import { z } from 'zod';
import LangEnum from '../../../lang/LangEnum';
import zodValidation from '../../../lib/zodValidation';
import { MIN_PASSWORD_LENGTH } from '../../../utils/constants';
import { TranslateType } from '../../translation/translationContext.types';
import { ActivationFormData } from '../types/login.types';

const buildActivationValidationSchema = (translate: TranslateType) => {
  const minLengthMessage = translate(LangEnum.PROFILE_USER_FORM_PASSWORD_VALIDATION, {
    min: MIN_PASSWORD_LENGTH,
  });

  return z
    .object({
      name: z.string({ error: LangEnum.GLOBAL_REQUIRED }).trim().min(1, LangEnum.GLOBAL_REQUIRED),
      surname: z
        .string({ error: LangEnum.GLOBAL_REQUIRED })
        .trim()
        .min(1, LangEnum.GLOBAL_REQUIRED),
      email: z
        .string({ error: LangEnum.GLOBAL_REQUIRED })
        .trim()
        .min(1, LangEnum.GLOBAL_REQUIRED)
        .pipe(z.email(LangEnum.GLOBAL_INVALID_EMAIL)),
      password: z
        .string({ error: LangEnum.GLOBAL_REQUIRED })
        .trim()
        .min(1, LangEnum.GLOBAL_REQUIRED)
        .pipe(z.string().min(MIN_PASSWORD_LENGTH, minLengthMessage)),
      confirmPassword: z
        .string({ error: LangEnum.GLOBAL_REQUIRED })
        .trim()
        .min(1, LangEnum.GLOBAL_REQUIRED)
        .pipe(z.string().min(MIN_PASSWORD_LENGTH, minLengthMessage)),
      phone: z.string({ error: LangEnum.GLOBAL_REQUIRED }).trim().min(1, LangEnum.GLOBAL_REQUIRED),
    })
    .refine((values) => values.confirmPassword === values.password, {
      path: ['confirmPassword'],
      message: LangEnum.PROFILE_USER_FORM_DIFFERENT_PASSWORDS,
    });
};

export const validateActivationForm = (values: ActivationFormData, translate: TranslateType) =>
  zodValidation(buildActivationValidationSchema(translate))({
    ...values,
    phone:
      values?.phone && values.countryCode
        ? values.phone.slice(values.countryCode.length)
        : undefined,
  });
